// TODO Define a proper and strict interface with a library
const AvastConfig = {
    images: {
        Regular: {
            HEADER_BRAND_LOGO: require("../images/avast/regular/header_brand_logo.png"),
            HEADER_BROWSER_LOGO: require("../images/avast/regular/header_browser_logo.png"),
            HEADER_A: require("../images/avast/regular/header_a.png"),
            BROWSER_BACKGROUND: require("../images/avast/regular/browser_background.png"),
            BROWSER_BACKGROUND_MOBILE: require("../images/avast/regular/browser_background_mobile.png"),
            SWITCH: require("../images/avast/regular/switch.png"),
            FEATURE_ADVANCED: require("../images/avast/regular/feature_advanced.png"),
            FEATURE_FASTER: require("../images/avast/regular/feature_faster.png"),
            FEATURE_PRIVACY: require("../images/avast/regular/feature_privacy.png"),
            SWITCHING: require("../images/avast/regular/switching.png"),
            FEATURE_TICK: require("../images/avast/regular/feature_tick.png"),
            BLOCK_CARD: require("../images/avast/regular/block_card.png"),
            SHOP_CARD: require("../images/avast/regular/shop_card.png"),
            ENCRYPT_CARD: require("../images/avast/regular/encrypt_card.png"),
            VPN_CARD: require("../images/avast/regular/vpn_card.png"),
            TRACK_CARD: require("../images/avast/regular/track_card.png"),
            LEAK_CARD: require("../images/avast/regular/leak_card.png"),
            PLAY_STORE: require("../images/avast/regular/playstore.png"),
            APP_STORE: require("../images/avast/regular/appstore.png"),
            QR_CODE: require("../images/avast/regular/qrcode.png"),
            FREE_BROWSING: require("../images/avast/regular/freebrowsing.png"),
            SECURE_VPN: require("../images/avast/regular/securevpn.png"),
            QR_PHONE: require("../images/avast/regular/qrphone.png"),
        },
        Retina: {
            HEADER_BRAND_LOGO: require("../images/avast/retina/header_brand_logo.png"),
            HEADER_BROWSER_LOGO: require("../images/avast/retina/header_browser_logo.png"),
            HEADER_A: require("../images/avast/retina/header_a.png"),
            BROWSER_BACKGROUND: require("../images/avast/retina/browser_background.png"),
            BROWSER_BACKGROUND_MOBILE: require("../images/avast/retina/browser_background_mobile.png"),
            SWITCH: require("../images/avast/retina/switch.png"),
            FEATURE_ADVANCED: require("../images/avast/retina/feature_advanced.png"),
            FEATURE_FASTER: require("../images/avast/retina/feature_faster.png"),
            FEATURE_PRIVACY: require("../images/avast/retina/feature_privacy.png"),
            SWITCHING: require("../images/avast/retina/switching.png"),
            FEATURE_TICK: require("../images/avast/retina/feature_tick.png"),
            BLOCK_CARD: require("../images/avast/retina/block_card.png"),
            SHOP_CARD: require("../images/avast/retina/shop_card.png"),
            ENCRYPT_CARD: require("../images/avast/retina/encrypt_card.png"),
            VPN_CARD: require("../images/avast/retina/vpn_card.png"),
            TRACK_CARD: require("../images/avast/retina/track_card.png"),
            LEAK_CARD: require("../images/avast/retina/leak_card.png"),
            PLAY_STORE: require("../images/avast/regular/playstore.png"),
            APP_STORE: require("../images/avast/regular/appstore.png"),
            QR_CODE: require("../images/avast/regular/qrcode.png"),
            FREE_BROWSING: require("../images/avast/regular/freebrowsing.png"),
            SECURE_VPN: require("../images/avast/regular/securevpn.png"),
            QR_PHONE: require("../images/avast/regular/qrphone.png"),
        },
        Both: {
            FAVICON: require('../images/avast/both/favicon.ico'),
            HEADER_A_MOBILE: require('../images/avast/both/header_a_mobile.png'),
            HEADER_A_MOBILE_1020: require('../images/avast/both/header_a_mobile_1020.png'),
        }
    },
    messages: {
        "en": require("../locales/avast/en")
    },
    resources: {
        GA_HEAD: "GTM-PZ48F8",
        GA_BODY: "https://www.googletagmanager.com/ns.html?id=GTM-PZ48F8",
        WEB_LINK: "https://www.avast.com",
        COOKIES_LINK: `https://www.avast.com/${window.navigator.language.toLocaleLowerCase()}/privacy-policy#cookies`,
        FAQ_LINK: "https://support.avast.com/article/Secure-Browser-FAQ/",
        DOWNLOAD: {
            windows: "https://www.avast.com/download-thank-you.php?product=ASB-CID&tag=6302",
            mac: "https://www.avast.com/download-thank-you.php?product=ASB-MAC-CID&tag=6302",
            android: "https://play.google.com/store/apps/details?id=com.avast.android.secure.browser&referrer=utm_source%3Davast_com%26utm_medium%3Dblog",
            ios: "https://apps.apple.com/app/apple-store/id1517761023?pt=421899&ct=avast_com%20blog"
        }
    },
    fonts: {
        MAIN: "Proxima Nova",
        SECONDARY: "Proxima Nova"
    },
    styles: {},
    colors: {
        HEADER_BACKGROUND: "#ffffff",
        HEADER_SEPARATOR: "#d4d2e6",
        MAIN_TEXT: "#261c6a",
        SECONDARY_TEXT: "#ffffff",
        FEEDBACK_BUTTON: "#00855c",
        FEEDBACK_BUTTON_HOVER: "#017752",
        WHATS_NEW_TEXT: "#ffffff",
        FEATURE_NAME: "#261c6a",
        FOOTER_BACKGROUND: "#160e53",
        FOOTER_LINK: "#ffffff",
        FOOTER_LINK_HOVER: "#a9adb7",
        COOKIES_BAR: "#0c053e",
        CARDS_BACKGROUND: "#f8f8fc",
        STEPS_BACKGROUND: "#4e22d0"
    }
};

export default AvastConfig;
